/**
 * Social science project covers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_project_pages`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const socialScienceProjectCoversPack: ToilePack = {
    slug: 'social-science-project-covers',
    category: 'classroom',
    name: 'Social science project covers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'globe', label: 'Globe', subject: 'a cover with a globe and a compass around "SOCIAL SCIENCE"'},
        {key: 'map', label: 'Map', subject: 'a cover with an outline map and a flag'},
        {key: 'history', label: 'History', subject: 'a cover with a temple, a fort and a scroll'},
    ],
    styles: [
        {key: 'sketch', label: 'Sketch pens', style: 'outlined in black fineliner and filled in with bright sketch pens in flat even colour, neat hand-drawn lines with a slight wobble', palette: 'bright blues, greens, browns and reds', framing: 'centred on a white A4 sheet seen straight on with an even clean margin all round'},
        {key: 'pencil', label: 'Colour pencils', style: 'drawn in sharp colour pencils with soft layered shading and visible pencil strokes, a gentle hand-coloured finish', palette: 'earthy pencil tones of brown, green and sky blue', framing: 'filling a white A4 sheet seen straight on, a narrow pencil-ruled margin line inside the edge of the page'},
        {key: 'duo', label: 'Two-colour pen', style: 'drawn in black gel pen with one accent colour of highlighter, clean ink lines, minimal and tidy', palette: 'black ink with brown highlighter only', framing: 'on a cream notebook page seen straight on with a generous margin'},
    ],
    directions: ['civics', 'monuments', 'freedom fight'],
    directionHint: 'try: civics',
    seo: {
        title: 'Social science project covers: globe, map, history',
        metaDescription: 'Nine hand-drawn social science project covers: globe, map and history designs, in sketch pens, colour pencils or gel pen.',
        h1: 'Social science project covers: globe, map, history',
        tagline: 'Nine covers: globe, map and history, each in three pen styles.',
        intro: 'Front pages for a social science project file, drawn by hand with pens and colours. The globe cover has a globe and a compass around the words SOCIAL SCIENCE. The map cover has an outline map and a flag. The history cover has a temple, a fort and a scroll. Each comes in three pen styles. Type a twist, such as civics, monuments or freedom fight, and the same three subjects can take it.',
        useCases: [
            'a social science project for school',
            'a geography or civics file',
            'a history project folder',
        ],
        faq: [
            {q: 'What is on the history cover?', a: 'A temple, a fort and a scroll.'},
            {q: 'What is on the map cover?', a: 'An outline map with a flag. It is drawn for decoration, not as a survey map.'},
            {q: 'What are the three styles?', a: 'Sketch pens use bright flat colour inside black fineliner outlines. Colour pencils give soft layered shading in pastel tones. Two-colour pen is black gel ink with one highlighter colour.'},
            {q: 'Can I ask for a freedom fight cover?', a: 'Yes. Type it as a twist and it is a request for the same layouts, not a promised result.'},
        ],
    },
}
